import { Box, Button, Card, Paper, Typography, Grid } from "@mui/material";
import pxToRem from "../../../../../Themes/Functions/pxToRem";
import TopUpDialog from "./TopUpdialog";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ChipButton from "../../../../../Components/ChipButton";

const BalanceCard = (props) => {
  const { screenData, paymentTypes, unpaidTickets = [], topupRequests = [], onTopupSuccess } = props;
  const navigate = useNavigate();
  const paymentMethods = screenData?.paymentMethods ? screenData.paymentMethods : [];
  const paymentTypeData = paymentTypes ? paymentTypes : [];
  const [open, setOpen] = useState(false);

  // Calculate unpaid ticket total
  const unpaidTotal = unpaidTickets.reduce((sum, ticket) => sum + (ticket.totalCost || 0), 0);
  const currentBalance = screenData?.balance ? Number(screenData.balance) : 0;
  const availableBalance = currentBalance - unpaidTotal;
  
  // Detect if current login is a PARTNER user; if yes, hide Top Up
  let isPartnerLogin = false;
  let isRootAdmin = false;
  try {
    const authInfo = JSON.parse(localStorage.getItem('authInfo') || '{}');
    const principalInfo = authInfo.principalInfo || {};
    const roles = principalInfo.roles || [];
    const orgType = (principalInfo.organisationType || principalInfo.organizationType || '').toString();
    const roleHasPartner = Array.isArray(roles) && roles.some(r => {
      const val = typeof r === 'string' ? r : (r?.name || r?.code || r?.authority || '');
      const s = String(val);
      return /partner/i.test(s);
    });
    const roleHasRoot = Array.isArray(roles) && roles.some(r => {
      const val = typeof r === 'string' ? r : (r?.name || r?.code || r?.authority || '');
      const s = String(val);
      return /(root\s*admin|role_root_admin|root_admin)/i.test(s);
    });
    const orgIsPartner = orgType && orgType.toUpperCase() === 'PARTNER';
    // Partner login means role/org indicates partner, but not ROOT_ADMIN
    isPartnerLogin = (roleHasPartner || orgIsPartner) && !roleHasRoot;
    isRootAdmin = !!roleHasRoot;
  } catch (e) {
    isPartnerLogin = false;
    isRootAdmin = false;
  }

  const handleClickOpen = () => {
    // Navigate to enhanced topup page
    navigate('/account/wallet/topup');
  };

  const _handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <TopUpDialog 
        paymentMethods={paymentMethods} 
        paymentTypes={paymentTypeData} 
        open={open} 
        onClose={_handleClose}
        onSuccess={onTopupSuccess}
      />
      <Card
        sx={{
          padding: pxToRem(8),
          width: '100%',
          boxShadow: 3,
          borderRadius: 2,
        }}
      >
        <Grid container spacing={2} alignItems="flex-start">
          {/* Left side - Main Balance */}
          <Grid item xs={12} md={7}>
            <Box>
              <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.1, fontWeight: 600, fontSize: '0.8rem', lineHeight: 1 }}>
                {isRootAdmin ? 'Thaklis Account Balance' : 'Wallet Balance'}
              </Typography>
              <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', lineHeight: 1.1, fontSize: '1.8rem' }}>
                {currentBalance.toFixed(2)} <span style={{ fontSize: '1.05rem', fontWeight: 'normal', color: '#666' }}>AED</span>
              </Typography>
            </Box>
          </Grid>

          {/* Right side - Available Balance and Unpaid Tickets */}
          <Grid item xs={12} md={5}>
            <Box sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: 1.2
            }}>
              {/* Available Balance */}
              <Box sx={{
                p: 0.8,
                borderRadius: 1,
                bgcolor: '#f0f8f5',
                border: '1px solid #b2dfdb',
                textAlign: 'center'
              }}>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.2, fontSize: '0.72rem', fontWeight: 600, lineHeight: 1 }}>
                  Available Balance
                </Typography>
                <Typography variant="body1" fontWeight="bold" color={availableBalance >= 0 ? '#2e7d32' : 'error.dark'} sx={{ mb: 0.1, fontSize: '1.2rem', lineHeight: 1 }}>
                  {availableBalance.toFixed(2)}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', lineHeight: 1 }}>
                  After unpaid
                </Typography>
              </Box>

              {/* Unpaid Tickets */}
              <Box sx={{
                p: 0.8,
                borderRadius: 1,
                bgcolor: '#fff3e0',
                border: '1px solid #ffe0b2',
                textAlign: 'center'
              }}>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.2, fontSize: '0.72rem', fontWeight: 600, lineHeight: 1 }}>
                  Unpaid Tickets
                </Typography>
                <Typography variant="body1" fontWeight="bold" color="#e67c3b" sx={{ mb: 0.1, fontSize: '1.2rem', lineHeight: 1 }}>
                  {unpaidTotal.toFixed(2)}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', lineHeight: 1 }}>
                  {unpaidTickets.length} ticket{unpaidTickets.length !== 1 ? 's' : ''}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </>
  );
};

export default BalanceCard;
